<template>
  <div class="content">
    <div class="md-layout md-alignment-center">
      <div
        class="md-layout-item md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <md-card>
          <md-card-header data-background-color="secondary">
            <h4 class="title">Shopping Cart</h4>
          </md-card-header>
          <md-card-content>
            <div class="errors">
              <ul>
                <li v-for="(item, id) in errors" :key="id">{{ item }}</li>
              </ul>
            </div>
            <cart-table />
            <div class="md-layout md-alignment-top-space-between mt-5">
              <div
                class="md-layout-item md-size-50 md-xsmall-size-100 md-small-size-75 md-medium-size-60 md-large-size-40 md-xlarge-size-30"
              >
                <md-card class="p-4">
                  <h6>New price of the Buyer’s Pass Fees for 2024-2025</h6>
                  <ul>
                    <li>General Trading Area Pass ONLY - $63.80 incl GST</li>
                    <li>Flower Market ONLY - $36.90 incl GST</li>
                    <li>General Trading Area AND Flower Market Pass - $100.70 incl GST</li>
                  </ul>
                </md-card>
              </div>

              <div
                class="md-layout-item md-size-50 md-xsmall-size-100 md-small-size-75 md-medium-size-60 md-large-size-40 md-xlarge-size-30"
              >
                <order-summary-table />
              </div>
            </div>
            <div class="md-layout md-alignment-center-right">
              <md-button
                class="md-invalid mx-sm-3"
                @click="$store.dispatch('clearCart')"
                >Clear Cart</md-button
              >
              <md-button class="md-primary" @click="checkout"
                >Continue to Checkout</md-button
              >
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import CartTable from "../Tables/cartTable.vue";
import OrderSummaryTable from "../Tables/orderSummaryTable.vue";
export default {
  components: {
    CartTable,
    OrderSummaryTable
  },
  data() {
    return {
      errors: []
    };
  },
  methods: {
    checkout() {
      this.errors = [];

      if (!this.$store.getters.cartCanPurchase) {
        this.$toast.error("Please select a pass type for each user.");
        return;
      }

      this.$router.push("/checkout");
    }
  }
};
</script>
